var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-warapper"},[_c('AppHeader'),_c('AppMain'),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }